(function($){
    $( "form" ).submit(function() {
       $(this).find('.wpcf7-spinner').addClass('ajax-loader').addClass('is-active');
    });
    var regexPatterns = {
        "email" : /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        "tel" : /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/i
    };

    var disallowedEmailDomains = [
        'gmail.com',
        'yahoo.com',
        'gmx.com',
        'hotmail.com',
        'aon.com',
        'outlook.com',
        'icloud.com',
        'gmail.',
        'yahoo.',
        'gmx.',
        'hotmail.',
        'aon.',
        'outlook.',
        'icloud.',
        'mail.com',
        'mail.ru',
        'aol.com',
        'burjnet.ru',
        'msn.com',
        'felixkanar.ru',
        'yandex.com',
        'bk.ru',
        'bestoptionseo.com',
        'explainmybusiness.com',
        'tenpathsolutions.com',
        'fifatools.com',
        't-online.de',
        'business-capital-advisors.com',
        'aplana.us',
        'service-stieler.de',
        'talkwithcustomer.com',
        'brturbo.com.br',
        'free.fr',
        'mailinator.com',
        'worldtrafficsolutions.xyz',
        'evrosis.com',
        'aliasx.de',
        'jayzfanz.info',
        'wanadoo.fr',
        'ybb.ne.jp',
        'centtip.xyz',
        'rank.expert',
        'seznam.cz',
        'sofortsurf.de',
        'twoatsix.com',
        'pharusa.biz',
        'get-more-leads-now.com',
        'telesourcia.com',
        'secretsales.com',
        'googlemail.com',
        'live.com.mx',
        'live.com',
        'eckerd.com',
        'seznam.cz',
        'walla.co.il',
        'walla.com',
        'mysmallbusinessfundingnow.info',
        'jelve.com',
        'alychidesigns.com',
        'fiestasycopas.com',
        'suda2.pw',
        'clr.com',
        'etvision.net.il',
        'tecnoshopp.com',
        'hanmail.net',
        'ngi.de',
        'businesscapital247.com',
        'bol.com.br',
        'your-business-funded-now.com',
        'gotmail.net',
        'stargate.net',
        'pgi.com.sg',
        'onlineusar.biz',
        'naver.com',
        'info89.ru',
        'toads.pgh.pa.us',
        'belgacom.net',
        'web.de',
        'harley-davidson.com',
        'your-business-funding-now.info',
        'polioneis-reborb.com',
        'freenet.de',
        'cmail.net',
        'clintonwis.com',
        'issyvonrock.com',
        'perfectmedialab.com',
        'doalab.com',
        'intermetric.de',
        'voipoffice.com',
        'copping75.freshbreadcrumbs.com',
        'chrismansearch.com',
        'google.com',
        'mail.huji.ac.il',
        'gramag.ch',
        'verizon.net',
        'skynet.be',
        'voila.fr',
        'g-t-t.net',
        'andersencorp.com',
        'usrbc.org',
        'za.cyberhome.ne.jp',
        'ha.com',
        'shaw.ca',
        'fdfdf.namnerbca.com',
        'autorambler.ru',
        'zen-tao.de',
        'live.fr',
        'cuvox.de',
        'Pioneers.io',
        'nypa.gov',
        'visitorsmax.icu',
        'businessseo1.top',
        'pitman.com',
        'op.pl',
        'eccic.com',
        'rediffmail.com',
        'ya.ru',
        'cox.net',
        'yandex.ru',
        'epost.de',
        'libero.it',
        'e-mail.com',
        'skinvision.com',
        'vape-marketing.com',
        'niesleevlers.info',
        'hollandandbarrett.com',
        'jabpid.com',
        'cyber-wizard.com',
        'business-loans-funded.info',
        'culturalcare.com',
        'rocketmail.com',
        'quincemarketinsights.com',
        'sina.com',
        'haar-mode.de',
        'dfasdf.namnerbca.com',
        'rambler.ru',
        'aztecinc.com',
        'dbzxxp.com',
        'tiscali.it',
        'imail8.net',
        'ema.il',
        'tradetracker.com',
        'greatvisitors.icu',
        'revlight.com.sg',
        'business-capital-fundings.info',
        'e1.ru',
        'course.com',
        'chinaregistry.org.cn',
        'onlinehome.de',
        'easyblogs.biz',
        'keystonefoods.com',
        'lycos.de',
        'e-mail.net',
        'financier.com',
        'profund-365.com',
        'gmai.com'
    ];

    //Check if value of input is set for validation
    $('.download-form-labels input').on('focusout change', function() {
        var $input = $(this),
            $inputRow = $input.closest('.download-form-labels');

        $input.IVvalidateInput();
    });

    //Remove validation tooltip on focusin
    // $('.download-form-labels input').on('focusin', function() {
    //     var $input = $(this),
    //         $inputRow = $input.closest('.download-form-labels');
    //
    //     $('.download-form-labels').not($inputRow).find('.wpcf7-not-valid-tip').remove();
    // });

    //Inline live validation
    $('.download-form-labels input').on('keyup', function() {
        var $input = $(this);

        $input.IVvalidateInput();
    });

    $.fn.extend({
        IVvalidateInput: function() {
            return this.each(function() {
                var $input = $(this),
                    required = (($input.attr('required') || $input.hasClass('wpcf7-validates-as-required')) && true) || false,
                    value = ($input.val() && $input.val()) || false,
                    regex = ($input.attr('data-regex')) || false,
                    min = ($input.attr('min')) || false,
                    max = ($input.attr('max')) || false,
                    $inputRow = $input.closest('.if-form-row'),
                    inputType = $input.attr('type');

                $inputRow.find('.js-if-tooltip-error').remove();

                if ((required && !value) || (inputType == 'checkbox' && !$input.is(':checked'))) {
                    return $input.IVdisplayError('The field is required.');
                }

                if (inputType == 'email') {
                    if (!regexPatterns[inputType].test($input.val()) && value) {
                        return $input.IVdisplayError('E-mail address is not valid.');
                    }

                    if ($input.hasClass('validate-company-email')) {
                        var emailDomain = value.split('@');

                        if (disallowedEmailDomains.indexOf(emailDomain[1]) >= 0) {
                            return $input.IVdisplayError('Please provide your business email.');
                        }
                    }
                }

                if (inputType == 'tel') {
                    if (!regexPatterns[inputType].test($input.val()) && value) {
                        return $input.IVdisplayError('Phone number is not valid.');
                    }
                }

                if (min || max) {
                    if (parseInt(value) < min || parseInt(value) > max) {
                        return $input.IVdisplayError();
                    }
                }

                if (value) {
                    return $input.IVdisplayValid();
                }

                $input.IVresetValidation();
            });
        },
        IVdisplayError: function(errorMessage) {
            return this.each(function() {
                var $input = $(this),
                    $inputRow = $input.closest('.download-form-labels');

                var nofillError = $input.data('error');

                    $input.attr("data-valid", 'false');
                    $input.addClass('wpcf7-not-valid');
                    $inputRow.find('span.wpcf7-not-valid-tip').remove();
                    $inputRow.append('<span role="alert" class="wpcf7-not-valid-tip">'+errorMessage+'</span>');
            });
        },
        IVdisplayValid: function() {
            return this.each(function() {
                var $input = $(this),
                    $inputRow = $input.closest('.download-form-labels')

                    $input.removeClass('wpcf7-not-valid');
                    $inputRow.find('span.wpcf7-not-valid-tip').remove();
            });
        },
        IVresetValidation: function() {
            return this.each(function() {
                var $input = $(this),
                    $inputRow = $input.closest('.download-form-labels');

                    $input.removeClass('wpcf7-not-valid');
                    $inputRow.find('span.wpcf7-not-valid-tip').remove();
            });
        }
    });

    document.addEventListener( 'wpcf7submit', function( event ) {
        $('.ajax-loader').removeClass('is-active');
        if (event.detail.apiResponse.status === 'mail_sent') {
            var $form = $('#'+event.detail.id);
            var $modal = $form.closest('.reveal-modal');        
            $modal.find('.form-headline-box').hide();
        }
    }, false );
})(jQuery);
